export const ruleNames = {
    'nightDriving': 'Night Driving',
    'speed': 'Over Speed',
    'routeViolation': 'Route Violation',
    'maxHalt': 'Long Halt',
    'temperature': 'Temperature Out of Range',
    'fuelEfficiency': 'Fuel Efficiency',
    'fuelConsumption': 'Fuel Consumption',
    'minGeneratorHours': 'Generator Hours', //not used
    'minGeneratorHoursPercentage': 'Generator Hours Percentage', //not used
};

const valueWithUnit = (key, unit) => (rules = {}) => {
    const value = rules?.[key];
    if (value === undefined || value === null) {
        return '-';
    }
    return `${value} ${unit}`;
};

export const ruleLimitFormatters = {
    nightDriving: (rules = {}) => {
        const { drivingStartTime, drivingEndTime } = rules || {};
        if (drivingStartTime && drivingEndTime) {
            return `${drivingStartTime} to ${drivingEndTime}`;
        }
        return '-';
    },
    speed: valueWithUnit('speedLimit', 'Km/h'),
    maxHalt: valueWithUnit('maxHaltTime', 'Hours'),
    routeViolation: valueWithUnit('routeViolationThreshold', 'Km'),
    fuelConsumption: valueWithUnit('maxFuelConsumption', 'L'),
    fuelEfficiency: valueWithUnit('minFuelEfficiency', 'Km/L'),
};
